import React from "react";

import "./styles/global.css";

import Home from './pages/Home'

function App() {
  return (
    <Home />
  )
}

export default App;
